module.exports = __webpack_public_path__ + "img/12-S & M Media Steel & Metal News.8cfbc736.png";